<template>
  <label class="checkbox">
    <input type="checkbox" v-model="checked" />

    <span class="checkbox__mark"></span>
    <p>{{ label }}</p>
  </label>
</template>

<script>
export default {
  props: {
    name: String,
    label: String,
    value: [Boolean, Number]
  },
  data() {
    return {
      checked: false
    }
  },
  watch: {
    checked: {
      handler(newVal) {
        this.checked = newVal
        this.$emit("input", this.checked)
      },
      immediate: true
    },
    value: {
      handler(newVal) {
        this.checked = newVal
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox {
  // margin-left: 30px;
  display: flex;
  align-items: center;
  transform: translateY(-20%);
  input {
    display: none;
    // background: #F00;
    &:checked + .checkbox__mark {
      box-shadow: 0px 0px 0px 1px #fbac2e;
      border-color: #fff;
      border-width: 8px;
      background-color: #fbac2e;
    }
  }
  .checkbox__mark {
    display: inline-block;
    width: 25px;
    height: 25px;
    background: transparent;
    border: 1px solid #a4a5a6;
    // border-radius: 100px;
    transition: all 0.3s;
  }
  p {
    margin: 0;
    margin-left: 5px;
  }
}
.checkbox__mark {
  display: inline-block;
  width: 25px;
  height: 25px;
  background: transparent;
  border: 1px solid #a4a5a6;
  // border-radius: 100px;
  transition: all 0.3s;
}
p {
  margin: 0;
  margin-left: 5px;
}
</style>
